import { ComponentStyleConfig } from "@chakra-ui/react";

import { mobileStyleBreakpoint } from "util/styleHelpers";

const cardPadding = mobileStyleBreakpoint(3, 6);
const drawerPadding = 12;

const Card: ComponentStyleConfig = {
  parts: ["card", "header", "body"],
  baseStyle: {
    card: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    header: {
      w: "100%",
      pt: cardPadding,
      px: cardPadding,
      pb: 3,
      borderBottom: "2px solid",
      borderColor: "grey.200",
      display: "flex",
    },
    body: {
      w: "100%",
      p: cardPadding,
      display: "flex",
    },
  },
  variants: {
    rounded: {
      card: {
        boxShadow: "card",
        borderRadius: "sm",
      },
    },
    drawer: {
      card: {
        boxShadow: "none",
        borderRadius: 0,
      },
      header: {
        px: drawerPadding,
        pt: 8,
      },
      body: {
        px: drawerPadding,
      },
    },
  },
  defaultProps: {
    variant: "rounded",
  },
};

export default Card;
